export const platforms = [
  {
    id: 1,
    name: "Elso Club",
    description:
      "Empresa dedicada a brindar formación virtual para fortalecer el crecimiento personal y profesional, con cursos y profesores nacionales e internacionales.",
    logo: "/img/logos/elso.jpg",
    social: {
      web: "https://elso.club/",
      facebook: "https://www.facebook.com/people/ELSo-Club/100076152099534/?rdid=FdTfmojEcQ6SSALC&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FhrANg6aB%2F",
      instagram: "https://www.instagram.com/elso_club/?igsh=MWkzY2I1cnFsNmhxNQ%3D%3D"
    }
  },
  {
    id: 2,
    name: "De Una Marketing",
    description:
      "Empresa dedicada a ayudar a las personas a tener y mejorar su presencia digital y su Directorio De Una sobre Servicios y Turismo",
    logo: "/img/logos/deuna.png",
    social: {
      web: "https://deunamarketing.com/",
      facebook: "https://www.facebook.com/deunaglobal/",
      instagram: "https://www.instagram.com/deuna.global/?r=nametag"
    }
  },
  {
    id: 3,
    name: "Steps Consulting Corp",
    description:
      "Servicios especializados de consultoría tecnológica para empresas en Puerto Rico.",
    logo: "/img/logos/steps.png",
    social: {
      web: "https://stepsconsultingcorp.com/",
      facebook: "https://www.facebook.com/stepsconsultingcorp",
      instagram: "https://www.instagram.com/stepsconsulting/",
      youtube: "https://www.youtube.com/@stepsconsulting6192"
    }
  },
  {
    id: 4,
    name: "Cuponex",
    description:
      "Empresa que facilita la compra y venta de productos nuevos y usados, apoyando a las personas a generar ingresos, ahorrar y contribuir a una economía más accesible y circular.",
    logo: "/img/logos/cuponex.jpg",
    social: {
      web: "https://cuponex.net/",
      facebook: "https://www.facebook.com/people/CuponexNet/100064101638919/",
      instagram: "https://www.instagram.com/cuponex_net/"
    }
  },
{
  id: 5,
  name: "TiMi App",
  logo: "/img/logos/timi.jpg",
  description: "Herramienta de transporte que conecta a las personas con un transporte seguro y confiable...",
  social: {
    web: "https://timiapp.com",
    facebook: "https://facebook.com/timi",
    instagram: "https://instagram.com/timi"
  },
  extraLinks: [
    {
      url: "https://play.google.com/store/apps/details?id=timi.driver",
      tooltip: "TiMi Driver - Play Store",
      type: "play"
    },
    {
      url: "https://play.google.com/store/apps/details?id=timi.user",
      tooltip: "TiMi User - Play Store",
      type: "play"
    },
    {
      url: "https://apps.apple.com/app/id1234567890",
      tooltip: "TiMi Driver - App Store",
      type: "apple"
    },
    {
      url: "https://apps.apple.com/app/id0987654321",
      tooltip: "TiMi User - App Store",
      type: "apple"
    }
  ]
}
];
